// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iCua","type":"styles_type__N4Urd","choices":"styles_choices__2Oh59"};